(function () {

  /* =====================================
     ANIMAÇÃO DOS BLOCOS
  ===================================== */

  function animateBlocos(container) {

    if (!container) return;

    const blocos = container.querySelectorAll(".tm-bloco");

    blocos.forEach(bloco => bloco.classList.remove("show"));

    void container.offsetHeight;

    blocos.forEach((bloco, index) => {
      setTimeout(() => {
        bloco.classList.add("show");
      }, 220 * index);
    });

  }

  /* =====================================
     INICIALIZA TABELA
  ===================================== */

  function initTabelaMedidas() {

    const wrapper = document.querySelector(".tm-wrapper");

    if (!wrapper) return;

    if (wrapper.dataset.initialized === "true") return;

    wrapper.dataset.initialized = "true";

    /* =====================================
       TABS DE TAMANHO
    ===================================== */

    const tabs = wrapper.querySelectorAll(".tm-tab");
    const contents = wrapper.querySelectorAll(".tm-content");

    tabs.forEach(tab => {

      tab.addEventListener("click", function () {

        tabs.forEach(item => item.classList.remove("active"));
        contents.forEach(item => item.classList.remove("active"));

        this.classList.add("active");

        const targetContent =
          wrapper.querySelector(`[data-content="${this.dataset.tab}"]`);

        if (!targetContent) return;

        targetContent.classList.add("active");

        animateBlocos(targetContent);

      });

    });

    /* =====================================
       GUIA DE MEDIÇÃO
    ===================================== */

    const guideTabs = wrapper.querySelectorAll(".tm-guide-tab");
    const guideContents = wrapper.querySelectorAll(".tm-guide-content");

    guideTabs.forEach(tab => {

      tab.addEventListener("click", function () {

        guideTabs.forEach(item => item.classList.remove("active"));
        guideContents.forEach(item => item.classList.remove("active"));

        this.classList.add("active");

        wrapper
          .querySelector(`[data-guide-content="${this.dataset.guide}"]`)
          ?.classList.add("active");

      });

    });

    /* =====================================
       CARROSSEL DAS TABS
    ===================================== */

    const tabsContainer = wrapper.querySelector(".tm-tabs");

    const leftArrow = wrapper.querySelector(".tm-tabs-arrow--left");
    const rightArrow = wrapper.querySelector(".tm-tabs-arrow--right");

    if (tabsContainer && leftArrow && rightArrow) {

      function getStep() {

        const tab = tabsContainer.querySelector(".tm-tab");

        if (!tab) return 80;

        const gap = parseFloat(getComputedStyle(tabsContainer).gap) || 0;

        return tab.offsetWidth + gap;

      }

      function updateArrows() {

        const maxScroll =
          tabsContainer.scrollWidth -
          tabsContainer.clientWidth;

        leftArrow.classList.toggle(
          "hidden",
          tabsContainer.scrollLeft <= 5
        );

        rightArrow.classList.toggle(
          "hidden",
          tabsContainer.scrollLeft >= maxScroll - 5
        );

      }

      leftArrow.addEventListener("click", () => {

        tabsContainer.scrollBy({
          left: -getStep(),
          behavior: "smooth"
        });

      });

      rightArrow.addEventListener("click", () => {

        tabsContainer.scrollBy({
          left: getStep(),
          behavior: "smooth"
        });

      });

      tabsContainer.addEventListener("scroll", () => {
        requestAnimationFrame(updateArrows);
      });

      window.addEventListener("resize", updateArrows);

      requestAnimationFrame(updateArrows);

    }

    /* =====================================
       PRIMEIRA ANIMAÇÃO
    ===================================== */

    animateBlocos(
      wrapper.querySelector(".tm-content.active")
    );

  }

  /* =====================================
     INIT
  ===================================== */

  document.addEventListener(
    "DOMContentLoaded",
    initTabelaMedidas
  );

})();